module.exports = __webpack_public_path__ + "img/u_web-grid-alt.19215a30.svg";